import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { DoodApiError } from '@shared/interfaces/error.interface';
import { EligiblePromotion } from '@core/services/api/bogof/bogof-api.service';

export const ELIGIBLE_PROMOTIONS_STORE_API_ACTIONS = createActionGroup({
  source: 'Dood/API/EligiblePromotions',
  events: {
    'Load Eligible Promotions Loading': emptyProps(),
    'Load Eligible Promotions Success': props<{ data: EligiblePromotion[] }>(),
    'Load Eligible Promotions Failure': props<{ error: DoodApiError }>(),
  },
});
